// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text-title[data-v-1a998f3c]{font-size:14px}.text-clear[data-v-1a998f3c]{font-size:12px}.marginNode[data-v-1a998f3c]{margin-bottom:2px}", ""]);
// Exports
module.exports = exports;
